/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';

import whitePlus from '../../../assets/images/white-plus.png';

const WhitePlus = ({ handleClick }) => (
  <div className="dropdown-btn">
    <button className="btn btn-link" onClick={handleClick}>
      <img src={whitePlus} alt="add" />
    </button>
  </div>
);

WhitePlus.propTypes = {
  handleClick: PropTypes.func
};

export default WhitePlus;
